import styled, { css } from "styled-components";
import { variant } from "@m/alchemy-theme";
import { Input } from "../input/Input.styled";
import { FieldAdornment } from "../field-adornment/FieldAdornment";
import { sizeMap } from "../field/Field.styled";
export const OuterWrapper = styled.div `
  --start-adornment-width: ${(props) => props.startAdornmentWidth ?? 0}px;
  --end-adornment-width: ${(props) => props.endAdornmentWidth ?? 0}px;
  --end-adornment-offset: ${(props) => props.endAdornmentOffset ?? 0}px;
  --adornment-size: ${(props) => sizeMap[props.sizeVariant || "default"].adornmentSize}px;
  --adornment-vertical-padding: ${(props) => sizeMap[props.sizeVariant || "default"].verticalPadding}px;
  display: flex;
  min-width: 0;
  max-width: 100%;

  ${FieldAdornment} {
    ${({ alignAdornments }) => css `
      ${alignAdornments && `align-items: ${alignAdornments};`};
      ${variant("alignAdornments", {
    start: css `
          padding-top: var(--adornment-vertical-padding);
        `,
    end: css `
          padding-bottom: var(--adornment-vertical-padding);
        `,
    center: css ``
})}
    `}

    ${(props) => props.sizeVariant &&
    props.sizeVariant !== "default" &&
    // If the svg width is the default (16), set the default height/width for the size. This allows custom sized svgs to take precedence
    css `
        svg[width="16"] {
          height: var(--adornment-size);
          width: var(--adornment-size);
        }
      `}
    ${({ disabled }) => disabled
    ? css `
            opacity: 0.5;
            cursor: not-allowed;
          `
    : ""};
  }
`;
export const InputContainer = styled.div `
  display: flex;
  position: relative;
  max-width: 100%;
  min-width: 0;
  ${({ isFullWidth }) => isFullWidth && "width:100%;"};
  ${Input} {
    margin-bottom: 0;
  }
`;
